/**
 * Description: 地址元素类型
 */
let DZYSLX = {
  SHENG: {type: '11', name: '省'},
  SHI: {type: '12', name: '市'},
  QX: {type: '13', name: '区(县)'},
  XIANG: {type: '21', name: '乡'},
  ZHEN: {type: '22', name: '镇'},
  JD: {type: '23', name: '街道'},
  SQ: {type: '31', name: '社区'},
  JWH: {type: '32', name: '居委会'},
  CWH: {type: '33', name: '村委会'},

  ZU : {type: '34', name: '组'},
  JLX: {type: '41', name: '街路巷'},
  XQ : {type: '42', name: '小区'},
  DWZZY: {type: '43', name: '单位(住宅)院'},
  MLPH: {type: '50', name: '门/楼牌号'},
  DY: {type: '61', name: '单元'},
  HS: {type: '62', name: '室(号)'},
  CENG: {type: '63', name: '层'}
}

export default DZYSLX
